import { copy } from 'angular';
var FaqItem = (function () {
    function FaqItem(apiItem) {
        copy(apiItem || {}, this);
    }
    return FaqItem;
}());
export { FaqItem };
